export const API_BASE_URL = process.env.NEXT_PUBLIC_MERCHANT_UTIL_API_URL;

export const API_TIMEOUT_MS = 60000;
export const POLL_INTERVAL_MS = 10000;

export const ACTIVE_STATUSES = ['pending', 'processing'];

export const FAILED_SKUS_PAGE_SIZE = 50;

export const MEGABYTES_IN_BYTES = 1024 * 1024;

export const TOKEN_CHECK_INTERVAL = 3 * 60 * 1000;

export const BULK_PROMO_SUPPORT_TICKET_URL =
    'https://petsmart.atlassian.net/wiki/spaces/PRM/pages/2041184374/Opening+a+Support+Ticket+for+Bulk+Discount+Code+Generation';
